import React, { useEffect, useRef, useState } from "react";
import BrandMark from "./BrandMark.jsx";
import { CloseIcon, MenuIcon } from "./icons.jsx";

export default function NavBar({ onNavigate, onSelectService, mode = "consumer" }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState(window.location.hash);
  const menuButtonRef = useRef(null);
  const menuWasOpen = useRef(false);

  useEffect(() => {
    const updateSection = () => setActiveSection(window.location.hash);
    window.addEventListener("hashchange", updateSection);
    window.addEventListener("popstate", updateSection);
    return () => {
      window.removeEventListener("hashchange", updateSection);
      window.removeEventListener("popstate", updateSection);
    };
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!mobileMenuOpen) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") setMobileMenuOpen(false);
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [mobileMenuOpen]);

  useEffect(() => {
    if (menuWasOpen.current && !mobileMenuOpen) menuButtonRef.current?.focus();
    menuWasOpen.current = mobileMenuOpen;
  }, [mobileMenuOpen]);

  const handleBrandClick = (e) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    onNavigate("/");
  };

  const handleAskClick = (e) => {
    e.preventDefault();
    onNavigate("/ask");
  };

  const handleCheckPaymentClick = (e) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    onNavigate("/check-a-payment");
  };

  const handleBespokeClick = (e) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    onNavigate("/bespoke");
  };

  const handlePhp2ShellClick = (e) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    onNavigate("/php2shell");
  };

  const handleSectionClick = () => setMobileMenuOpen(false);
  const isBespoke = ["bespoke", "php2shell", "payment", "legal"].includes(mode);
  const isBespokeHome = mode === "bespoke";
  const isPhp2Shell = mode === "php2shell";
  const isPayment = mode === "payment";
  const handleBespokeSectionClick = (section) => (event) => {
    setMobileMenuOpen(false);
    if (isBespokeHome) return;
    event.preventDefault();
    onNavigate(`/#${section}`, { section });
  };
  const handleBespokeServiceClick = (service) => (event) => {
    event.preventDefault();
    setMobileMenuOpen(false);
    onSelectService?.(service);
  };

  return (
    <header className="site-nav" data-scrolled={scrolled}>
      <div className="container site-nav__inner">
        <BrandMark onClick={handleBrandClick} />
        <nav className={`site-nav__links${mobileMenuOpen ? " is-open" : ""}`} aria-label="Primary" id="primary-navigation">
          {isBespoke ? (
            <>
              <a href={isBespokeHome ? "#review" : "/#review"} aria-current={isBespokeHome && activeSection === "#review" ? "location" : undefined} onClick={handleBespokeSectionClick("review")}>Security Review</a>
              <a href={isBespokeHome ? "#services" : "/#services"} aria-current={isBespokeHome && activeSection === "#services" ? "location" : undefined} onClick={handleBespokeSectionClick("services")}>Our Services</a>
              <a href="/php2shell" aria-current={isPhp2Shell ? "page" : undefined} onClick={handlePhp2ShellClick}>PHP2Shell</a>
              <a href="/check-a-payment" aria-current={isPayment ? "page" : undefined} onClick={handleCheckPaymentClick}>Check a Payment</a>
            </>
          ) : (
            <>
              <a href="#how-it-works" onClick={handleSectionClick}>How it works</a>
              <a href="#verdicts" onClick={handleSectionClick}>Assessments</a>
              <a href="#pocket" onClick={handleSectionClick}>Put Max in your pocket</a>
              <a href="/about-max" onClick={(e) => { e.preventDefault(); setMobileMenuOpen(false); onNavigate("/about-max"); }}>About Max</a>
              <a href="/check-a-payment" onClick={handleCheckPaymentClick}>Check a Payment</a>
              <a href="/bespoke" onClick={handleBespokeClick}>Bespoke</a>
            </>
          )}
        </nav>
        <div className="site-nav__cta">
          {isBespoke ? (
            <a className="btn btn-primary" href={isBespokeHome ? "#contact" : "/bespoke#contact"} onClick={handleBespokeServiceClick("")}>
              Contact AskMax
            </a>
          ) : (
            <a className="btn btn-primary" href="/ask" onClick={handleAskClick}>
              Ask Max
            </a>
          )}
          <button
            type="button"
            className="site-nav__menu-toggle"
            ref={menuButtonRef}
            aria-label={mobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-controls="primary-navigation"
            aria-expanded={mobileMenuOpen}
            onClick={() => setMobileMenuOpen((open) => !open)}
          >
            {mobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>
    </header>
  );
}
